export class AcceptTermsRequest {
  email: string;
  phone: string;
  acceptTerms: boolean;
}
